<template>
    <div class="summary-wrapper">
        <OKRSummaryBox :chartData="chartDataObjectives" titleString="objectives.objectives">
            <IconObjectiveChart :width="30" :height="30" :color="bluezinho500" class="icon" />
        </OKRSummaryBox>
        <OKRSummaryBox :chartData="chartDataKeyResults" titleString="keyResult.keyResult">
            <IconKey :width="30" :height="30" :color="bluezinho500" class="icon" />
        </OKRSummaryBox>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { colorsMixin } from '@/mixins'
import { sumByKey } from '@/lib/utils'
import OKRSummaryBox from './children/OKRSummaryBox'
import { IconKey, IconObjectiveChart } from '@/views/icons'

export default {
    name: 'OKRSummary',
    mixins: [colorsMixin],
    data() {
        return {
            borderWidth: 0.8,
            borderColor: '#c2c5c9',
        }
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    components: {
        IconKey,
        IconObjectiveChart,
        OKRSummaryBox,
    },
    methods: {
        updateColors(progress) {
            let value = progress.toFixed(0)
            if (value == 0) {
                return this.grayColor
            } else if (value > 0 && value < 30) {
                return this.dangerColor
            } else if (value >= 30 && value < 70) {
                return this.warningColor
            } else {
                return this.successColor
            }
        },
        percentageDiff(value) {
            return value >= 100 ? 0 : value - 100
        },
        calculateProgressPercentage(object, count, progress) {
            let totalCount = sumByKey(object, count)
            let totalProgress = sumByKey(object, progress)
            return totalProgress ? (totalProgress / totalCount).toFixed(2) * 100 : 0
        },
    },
    computed: {
        ...mapGetters({
            periods: 'periods',
        }),
        filteredInfoByPeriod() {
            return this.user.info_by_period.filter((info) => {
                return this.periods.includes(info.period_id)
            })
        },
        keyResultsPercentage() {
            return this.calculateProgressPercentage(this.filteredInfoByPeriod, 'key_results_count', 'sum_progress')
        },
        objectiveResultsPercentage() {
            return this.calculateProgressPercentage(
                this.filteredInfoByPeriod,
                'objectives_count',
                'objectives_progress'
            )
        },
        chartDataKeyResults() {
            return {
                datasets: [
                    {
                        backgroundColor: [this.updateColors(this.keyResultsPercentage), '#fff'],
                        data: [this.keyResultsPercentage.toFixed(0), this.percentageDiff(this.keyResultsPercentage)],
                        borderWidth: this.borderWidth,
                        borderColor: this.borderColor,
                    },
                ],
            }
        },
        chartDataObjectives() {
            return {
                datasets: [
                    {
                        backgroundColor: [this.updateColors(this.objectiveResultsPercentage), '#fff'],
                        data: [
                            this.objectiveResultsPercentage.toFixed(0),
                            this.percentageDiff(this.objectiveResultsPercentage),
                        ],
                        borderWidth: this.borderWidth,
                        borderColor: this.borderColor,
                    },
                ],
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.summary-wrapper {
    display: flex;
    flex-direction: row;
    gap: 5px;
    color: $bluezinho-500;
}
.icon {
    margin-right: 0.5rem;
}

@media only screen and (max-width: 60em) {
    .summary-wrapper {
        flex-direction: column;
        font-size: 14px !important;
    }
    .icon {
        margin: 0.5rem !important;
    }
}

@media only screen and (max-width: 96em) {
    .summary-wrapper {
        font-size: 12px;
    }
    .icon {
        margin-right: 0.4rem;
        margin-left: 0.4rem;
        height: 1rem;
    }
}
</style>
